module.exports = __webpack_public_path__ + "d0f388a1c894247f3de21eb704c08d4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shapes/circleborder.svg
// module id = 132
// module chunks = 1